import {Component, Inject, HostListener} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';


@Component({
    selector: 'app-delete-confirmation',
    templateUrl: './delete-confirmation.component.html',
    styleUrls: ['./delete-confirmation.component.scss']
})

export class DeleteConfirmationComponent {
    position : number;
    message : string = "Are you sure you want to delete this component ?";
    buttonText : string = "Delete component";
    constructor(
        private dialogRef: MatDialogRef<DeleteConfirmationComponent>,
        @Inject(MAT_DIALOG_DATA) data
    ) {
        this.position = data.position;
        this.message = data.message? data.message :this.message; 
        this.buttonText = data.buttonText? data.buttonText :this.buttonText; 
    }


    exit() {
        this.dialogRef.close(true);
    }

    close() {
        this.dialogRef.close(false);
    }

    @HostListener('window:keyup.esc') onKeyUp() {
        this.dialogRef.close(false);
    }
}
